import React, { useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import Select from 'react-select';
import './DateFilter.css';

const ColumnsSelectorDropdown = ({
  allColumns,
  localSelected,
  onLocalChange,
  onConfirmColumns,
  loading
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div
      className="dropdown columns-selector-dropdown"
      style={{ marginRight: '20px' }}>
      <button
        className="btn btn-sm btn-secondary dropdown-toggle"
        type="button"
        onClick={toggleDropdown}>
        Select Columns
      </button>
      {isOpen && (
        <div
          className="dropdown-menu show p-3"
          style={{ minWidth: '250px', position: 'absolute', zIndex: 1000 }}>
          {allColumns.map((col) => (
            <div key={col.dataField} className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id={`col-${col.dataField}`}
                checked={localSelected.includes(col.dataField)}
                onChange={(e) => onLocalChange(col.dataField, e.target.checked)}
              />
              <label
                className="form-check-label ml-2"
                htmlFor={`col-${col.dataField}`}>
                {col.text}
              </label>
            </div>
          ))}
          <button
            className="btn btn-sm btn-primary mt-2"
            onClick={() => {
              onConfirmColumns();
              toggleDropdown();
            }}
            disabled={loading}>
            Confirm Columns
          </button>
        </div>
      )}
    </div>
  );
};

const DateFilter = ({
  onFilterChange,
  defaultDates,
  accountManagers,
  filter,
  loading,
  showReplied,
  setShowReplied,
  showGoogleReviews,
  allColumns,
  onColumnsChange,
  initialSelectedColumns
}) => {
  const [startDate, setStartDate] = useState(
    new Date(defaultDates.startDate) || null
  );
  const [endDate, setEndDate] = useState(
    new Date(defaultDates.endDate) || null
  );

  const [localSelectedColumns, setLocalSelectedColumns] = useState(
    initialSelectedColumns
  );

  const handleLocalColumnChange = (dataField, isChecked) => {
    if (isChecked) {
      setLocalSelectedColumns([...localSelectedColumns, dataField]);
    } else {
      setLocalSelectedColumns(
        localSelectedColumns.filter((field) => field !== dataField)
      );
    }
  };

  const handleConfirmColumns = () => {
    if (onColumnsChange) {
      onColumnsChange(localSelectedColumns);
    }
  };

  const starsNames = [
    { id: '0', name: 'All' },
    { id: '1', name: 'One' },
    { id: '2', name: 'Two' },
    { id: '3', name: 'Three' },
    { id: '4', name: 'Four' },
    { id: '5', name: 'Five' }
  ];

  const statusList = [
    { id: '0', name: 'All' },
    { id: '1', name: 'Approved' },
    { id: '2', name: 'Not Approved' }
  ];

  const handleFilterChangeInternal = (val) => {
    if (startDate && endDate) {
      const filterObject = {
        ...filter,
        startDate: Math.floor(startDate.getTime() / 1000),
        endDate: Math.floor(endDate.getTime() / 1000)
      };
      onFilterChange(filterObject);
    } else {
      console.error('Seleccione ambas fechas');
    }
    if (val?.filter === 'stars')
      onFilterChange((prevValue) => ({ ...filter, stars: val.value }));
    if (val?.filter === 'manager')
      onFilterChange((prevValue) => ({ ...filter, manager: val.value }));
    if (val?.filter === 'status')
      onFilterChange((prevValue) => ({ ...filter, status: val.value }));
  };

  const handleFilterClear = () => {
    onFilterChange({});
  };

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-around px-4 py-3">
      <ColumnsSelectorDropdown
        allColumns={allColumns}
        localSelected={localSelectedColumns}
        onLocalChange={handleLocalColumnChange}
        onConfirmColumns={handleConfirmColumns}
        loading={loading}
      />

      <div className="d-flex align-items-center">
        <label className="mx-2 h-100" style={{ color: '#8392a5' }}>
          Date:
        </label>
        <DateTimePicker
          disabled={loading}
          onChange={(date) => setStartDate(date)}
          value={startDate}
          placeholder="Start Date"
          format="yyyy-MM-dd"
          clearIcon={null}
          calendarIcon={null}
          className="custom-datetime-picker"
        />
        <label className="mx-2">-</label>
        <DateTimePicker
          disabled={loading}
          onChange={(date) => setEndDate(date)}
          value={endDate}
          placeholder="End Date"
          format="yyyy-MM-dd"
          clearIcon={null}
          calendarIcon={null}
          className="custom-datetime-picker"
        />
        <button
          className="btn btn-sm btn-primary mg-l-10"
          disabled={loading}
          onClick={handleFilterChangeInternal}>
          Filter
        </button>
      </div>

      <div className="d-flex align-items-center">
        <label className="mx-2" style={{ color: '#8392a5' }}>
          Stars:
        </label>{' '}
        <Select
          styles={customStyles}
          isDisabled={loading}
          defaultValue={{ value: '0', label: 'All' }}
          value={
            filter?.stars
              ? { value: filter?.stars, label: starsNames[filter?.stars].name }
              : { value: '0', label: 'All' }
          }
          onChange={(val) =>
            handleFilterChangeInternal({ filter: 'stars', value: val.value })
          }
          options={starsNames.map((option) => ({
            value: option.id,
            label: option.name
          }))}
        />
      </div>
      <div className="d-flex align-items-center">
        <label className="mx-2" style={{ color: '#8392a5' }}>
          Account Manager:
        </label>
        <Select
          isDisabled={loading}
          styles={{
            ...customStyles,
            container: (provided) => ({ ...provided, width: '120px' })
          }}
          value={
            filter?.manager
              ? {
                  value: filter?.manager,
                  label: accountManagers.find(
                    (item) => item.id === filter?.manager
                  ).full_name
                }
              : { value: '0', label: 'All' }
          }
          onChange={(val) =>
            handleFilterChangeInternal({ filter: 'manager', value: val.value })
          }
          defaultValue={{ value: '0', label: 'All' }}
          options={accountManagers.map((option) => ({
            value: option.id,
            label: option.full_name
          }))}
        />
      </div>
      <div className="d-flex align-items-center">
        <label className="mx-2" style={{ color: '#8392a5' }}>
          Status:
        </label>
        <Select
          isDisabled={loading}
          styles={{
            ...customStyles,
            container: (provided) => ({ ...provided, width: '130px' })
          }}
          defaultValue={{ value: '0', label: 'All' }}
          value={
            filter?.status
              ? {
                  value: filter?.status,
                  label: statusList.find((item) => item.id === filter?.status)
                    .name
                }
              : { value: '0', label: 'All' }
          }
          onChange={(val) =>
            handleFilterChangeInternal({ filter: 'status', value: val.value })
          }
          options={statusList.map((option) => ({
            value: option.id,
            label: option.name
          }))}
        />
      </div>
      <div className="d-flex align-items-center">
        {showGoogleReviews && (
          <label
            className={`mx-2 btn btn-sm pd-x-15 btn-primary mg-l-5 ${
              loading ? 'disabled' : ''
            }`}
            onClick={() => setShowReplied(!showReplied)}>
            {showReplied ? 'Hide Replied' : 'Show Replied'}
          </label>
        )}
        {filter?.startDate ||
        filter?.endDate ||
        filter?.stars ||
        filter?.manager ||
        filter?.status ? (
          <button
            className="btn btn-sm pd-x-15 btn-secondary mg-l-5"
            disabled={loading}
            onClick={handleFilterClear}>
            Clear
          </button>
        ) : null}
      </div>
    </div>
  );
};

const customStyles = {
  container: (provided) => ({ ...provided, width: '60px' }),
  control: (provided) => ({ ...provided, maxHeight: '25px', minHeight: '8px' }),
  menu: (provided) => ({ ...provided }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#3b5998' : 'white'
  }),
  dropdownIndicator: (provided) => ({ ...provided, display: 'none' }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  valueContainer: (provided) => ({
    ...provided,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '2px',
    paddingLeft: '1px'
  }),
  input: (provided) => ({ ...provided, margin: 0, padding: 0 }),
  placeholder: (provided) => ({ ...provided, display: 'none' })
};

export default DateFilter;
